import script from "./RoundIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundIconButton.vue?vue&type=script&setup=true&lang=js"

import "./RoundIconButton.vue?vue&type=style&index=0&id=27e9b722&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e9b722"]])

export default __exports__